
import { Theme, responsiveFontSizes } from '@material-ui/core';

import { RequestState } from '@ngt/request-utilities';

import { IAuthenticatedUserStore, OnlinePatientManagement, authenticatedUserActions } from '@ngt/opms';
import { BctApiExtension, permissionsActions } from '@ngt/opms-bctapi';
import * as Dtos from '../api/dtos';
import bctLogo from '../assets/img/bct.png';
import { DrugManagementExtension } from '@ngt/opms-drugmanagement';
import { AppSettings } from '../AppSettings';
import { InvoiceManagementExtension } from '@ngt/opms-invoicemanagement';
import CambriaExtension from '../CambriaExtension';

const createOnlinePatientManagement = (
    user?: Dtos.GetUserResponse, 
    formMetadata?: Dtos.GetFormMetadataResponse,  
    reportSettings?: Dtos.GetReportSettingsResponse
) => {
        
    if (!user) {
        if (global.location.search) {
            global.location.href = '/auth/openiddict' + global.location.search;
            return;
        } else {
            global.location.href = '/auth/openiddict';
            return; 
        }
    }
    
    // if (!formMetadata) {
    //     throw Error("Form Metadata could not be retrieved!");
    // }

    if (!reportSettings) {
        throw Error("Report Settings could not be retrieved!");
    }

    const onlinePatientManagement = new OnlinePatientManagement({
        trialOptions: {
            organisationLogo: bctLogo,
            organisationName: "Breast Cancer Trials",
            trialName: "CAMBRIA-2",
            protocolId: "BCT 2302/AZ D8535C00001",
            homePageUrl: AppSettings.trialPortalUrl ?? 'https://trialportal.breastcancertrials.org.au/'
        },
        // serviceStackClient: new JsonServiceClient("/").apply(c => {
        //     c.basePath = "/api";
        //     c.headers = new Headers();
        // }),
        // serviceStackClient: DefaultClient("/", "/api")
        dtos: Dtos,
        storeOptions: {
            preloadState: {
                authenticatedUser: {
                    user,
                    loadState: {
                        state: RequestState.Success
                    }
                }
            }
        },
        themeOptions: {
            beforeThemeCreated: (themeOptions: any) => {
                return {
                    palette: {
                        primary: {
                            main: '#562c85'
                        },
                        secondary: {
                            main: '#e8078c'
                        },
                        background: {
                            default: '#e9ecef'
                        },
                    },
                    typography: themeOptions.typography
                };
            },
            afterThemeCreated: (theme: Theme) => {
                return responsiveFontSizes(theme);
            }
        },
        formMetadata: formMetadata?.formMetadata,
        extensions: [
            new BctApiExtension({

            }),
            new DrugManagementExtension({
                defaultUnit: 'Blister Pack',
                randomisedStatus: Dtos.PatientStateType.RandomisedOnAbemaciclib,
                patientCaption: (patient) => {
                    return (patient as Dtos.Patient)?.patientStateId == 2 ? 'Randomised - On Abemaciclib' : ((patient as Dtos.Patient)?.patientStateId == 1 ? 'Randomised - Off Abemaciclib' : '')
                },
                allowDrugShipmentPharmacistSelection: true,
                consignmentNumberLabel: 'Shipment Number',
                allowEditConsignmentNumber: false,
                drugShipmentGenerationLink: undefined
            }),
            new InvoiceManagementExtension({
                patientStateids: [2,3,4,7],
                maxClaimableAmount: 11850
            }) as any,
            new CambriaExtension({
                storeOptions: {
                    initialiseReducers: {
                        screenFailures: true
                    }
                }
            })
        ]
    });

    onlinePatientManagement.serviceStackClient.responseFilter = (res: Response) => {
        const state = onlinePatientManagement.store.getState() as IAuthenticatedUserStore;

        if (res.headers.has('openiddict-user-status') &&
            res.headers.get('openiddict-user-status') === 'unauthenticated' &&
            state.authenticatedUser.user) {
            onlinePatientManagement.store.dispatch(authenticatedUserActions.signoutAuthenticatedUser())
        }
        else if (res.headers.has('openiddict-user-update') &&
            res.headers.get('openiddict-user-update') === 'true' &&
            state.authenticatedUser.loadState.state !== RequestState.Pending) {
            onlinePatientManagement.store.dispatch(authenticatedUserActions.checkAuthenticatedUser());
            onlinePatientManagement.store.dispatch(permissionsActions.refresh());
        }
    }

    onlinePatientManagement.serviceStackClient.exceptionFilter = (res: Response, _) => {
        if (res.status === 401) {
            global.location.href = `/auth/openiddict?redirect=${encodeURIComponent(global.location.pathname + global.location.search)}`;
        }
    };

    return onlinePatientManagement
}

export default createOnlinePatientManagement;